import { render, staticRenderFns } from "./SingleTranscriptQueueMTA.vue?vue&type=template&id=2559e63f&"
import script from "./SingleTranscriptQueueMTA.vue?vue&type=script&lang=js&"
export * from "./SingleTranscriptQueueMTA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports